document.addEventListener( 'DOMContentLoaded', function () {
	const webviewParam = 'webview=1';

	function appendQueryParam( url ) {
		let [ baseUrl, hash ] = url.split( '#' );
		if ( baseUrl.includes( '?' ) ) {
			baseUrl += baseUrl.includes( 'webview=' ) ? '' : `&${ webviewParam }`;
		} else {
			baseUrl += `?${ webviewParam }`;
		}
		return hash ? `${ baseUrl }#${ hash }` : baseUrl;
	}

	function updateLinks() {
		const links = document.querySelectorAll( 'a' );
		links.forEach( function ( link ) {
			if ( link.href && ( link.origin === location.origin || link.href.startsWith( '/' ) ) ) {
				link.href = appendQueryParam( link.href );
			}
		} );
	}

	// Initial update
	updateLinks();

	// Observe DOM changes
	const observer = new MutationObserver( function ( mutations ) {
		mutations.forEach( function ( mutation ) {
			if ( mutation.type === 'childList' ) {
				updateLinks();
			}
		} );
	} );

	observer.observe( document.body, {
		childList: true,
		subtree: true,
	} );
} );
